import type { FaireReviewEntity } from "../../entity_types/review";

// Real per-product review for Gumball Poodle (b_1fc44661), pulled from Faire's
// live `GET /api/product-reviews/product/{product_token}` endpoint (review
// token pr_v85emynumz) — verbatim comment, real reviewer first name, location and rating.
export const review_gp8: FaireReviewEntity = {
  token: "review_gp8",
  type: "review",
  brandName: "Gumball Poodle",
  brandToken: "b_1fc44661",
  productToken: "p_yqkhe6q3c7",
  reviewType: "product",
  reviewerName: "Trina",
  reviewerLocation: "Symsonia, KY, United States",
  stars: 5,
  reviewText: "The humor in these socks will make them sell easily and fast!",
  reviewDate: "Sep 23, 2026",
  meta: {
    source: "api" as const,
    importedAt: "2026-10-12T05:40:00.000Z",
    importedBy: "entity-db-cli",
  },
};
